import i18next from 'i18next'
import { z } from 'zod'

import { transferListSchema } from 'components/Form/TransferList'
import { matchTypeValues } from 'features/inventory/page/types/matchType'

export const commonSchema = z.object({
  adUnitIds: transferListSchema,
  customVariableName: z.string(),
  customVariableTriggerEnabled: z.boolean(),
  customVariableValue: z.string(),
  domainId: z.string().nonempty(i18next.t('common:form.error.nonEmpty')),
  matchType: z.enum(matchTypeValues),
  name: z.string().nonempty(),
  onlySendAdRequestsForAssignedAdUnits: z.boolean(),
  path: z.string(),
  pathTriggerEnabled: z.boolean(),
})

export type CommonSchema = z.infer<typeof commonSchema>
